import React from "react";
import { Blinds } from "lucide-react";

export const getWindowIcon = (widget = null) => {
  const lucideIconProps = {
    size: 24,
    style: { paddingBottom: "2px" },
  };
  return <Blinds {...lucideIconProps} />;
};

export const getWindowSubtitle = (widget = null) => {
  if (!widget) return "";
  const position = widget?.items?.$w1?.value;
  if (position !== undefined && position !== null) {
    return `${position}`;
  }
  return "";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getWindowPatterns = () => {
  return ["basic.device.windowOpenClose"];
};
